/* import __COLOCATED_TEMPLATE__ from './media-toolbar.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { CALLOUT_BLOCK_BACKGROUND_COLORS, CALLOUT_BLOCK_BORDER_COLORS, HORIZONTAL_RULE_FALLBACK } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
import { CALLOUT_BLOCK_ICON } from './media-inserter/constants';
let MediaToolbar = (_dec = ref('videoInserterButton'), _class = class MediaToolbar extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "videoInserterButton", _descriptor2, this);
    _initializerDefineProperty(this, "isInsertingVideo", _descriptor3, this);
    _defineProperty(this, "calloutBlockIcon", CALLOUT_BLOCK_ICON);
  }
  get schema() {
    return this.args.composer.state.prosemirrorState.schema;
  }
  get disableInsertTableOption() {
    let {
      selectionIsInCallout,
      selectionIsInNestedList,
      selectionIsInTable,
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCallout || selectionIsInTable || selectionIsInNestedList || selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertCalloutOption() {
    let {
      selectionIsInCallout,
      selectionIsInNestedList,
      selectionIsInTable,
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCallout || selectionIsInTable || selectionIsInNestedList || selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertListOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertCodeOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertDividerOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertCollapsibleSectionOption() {
    let {
      selectionIsInCollapsibleSectionSummary,
      selectionIsInNestedList
    } = this.args.composer.state;
    return selectionIsInNestedList || selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertImageOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertVideoOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertButtonOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get disableInsertFileOption() {
    let {
      selectionIsInCollapsibleSectionSummary
    } = this.args.composer.state;
    return selectionIsInCollapsibleSectionSummary;
  }
  get videoInserterButtonRect() {
    if (!this.videoInserterButton) {
      return;
    }
    let boundingRect = this.videoInserterButton.getBoundingClientRect();
    return new DOMRect(boundingRect.x, boundingRect.top, boundingRect.width, boundingRect.height);
  }
  get showListToolbarIcons() {
    return this.schema.nodes.unorderedNestedList && this.schema.nodes.orderedNestedList && this.args.options?.showListToolbarIcon;
  }
  insertImage(file) {
    let pos = this.args.composer.state.prosemirrorState.selection.from;
    this.args.composer.commands.insertImageFileAtRange({
      from: pos,
      to: pos
    }, file);
    this.args.composer.commands.focus();
  }
  insertBlock(block) {
    this.isInsertingVideo = false;
    let pos = this.args.composer.state.prosemirrorState.selection.from;
    this.args.composer.commands.insertBlockAtRange({
      from: pos,
      to: pos
    }, block);
    this.args.composer.commands.focus();
  }
  cancelVideoInsertion() {
    this.isInsertingVideo = false;
  }
  insertButtonBlock() {
    this.insertBlock({
      type: 'button',
      text: ''
    });
  }
  insertCalloutBlock() {
    this.insertBlock({
      type: 'callout',
      style: {
        backgroundColor: CALLOUT_BLOCK_BACKGROUND_COLORS.grey,
        borderColor: CALLOUT_BLOCK_BORDER_COLORS.grey
      },
      content: [{
        type: 'paragraph',
        class: 'no-margin',
        text: ''
      }]
    });
  }
  insertCodeBlock() {
    this.insertBlock({
      type: 'code',
      text: ''
    });
  }
  openVideoInserter() {
    this.isInsertingVideo = true;
  }
  insertTableBlock() {
    this.insertBlock({
      type: 'table',
      rows: [{
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }, {
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }, {
        cells: [{
          content: []
        }, {
          content: []
        }, {
          content: []
        }]
      }]
    });
  }
  insertHorizontalRule() {
    this.insertBlock({
      type: 'horizontalRule',
      text: HORIZONTAL_RULE_FALLBACK
    });
  }
  insertNestedList(type) {
    this.args.composer.commands.toggleListType(type);
    this.args.composer.commands.focus();
  }
  async insertFile(file) {
    await this.args.composer.commands.addAttachment(file);
  }
  insertCollapsibleSection() {
    this.insertBlock({
      type: 'collapsibleSection',
      summary: {
        type: 'subheading',
        text: ''
      },
      content: [{
        type: 'paragraph',
        text: ''
      }]
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "videoInserterButton", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isInsertingVideo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "insertImage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelVideoInsertion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelVideoInsertion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertButtonBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertButtonBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertCalloutBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertCalloutBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertCodeBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertCodeBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openVideoInserter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openVideoInserter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertTableBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertTableBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertHorizontalRule", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertHorizontalRule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertNestedList", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertNestedList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertCollapsibleSection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertCollapsibleSection"), _class.prototype), _class);
export { MediaToolbar as default };